import React  from 'react'
import { Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux';
import AuthenticatedRedirect from './AuthenticatedRedirect'

const PublicRoute = () => {

	const { token } = useSelector(state => state.auth)
  
	return token ? <AuthenticatedRedirect /> : <Outlet/>
}

export default PublicRoute